module.exports = __webpack_public_path__ + "static/media/fanCleaning.4e7939f8.png";